import React from "react";
import OperationalSnapshotCard from "../components/OperationalSnapshotCard";

const AdminHomeTab = ({
  t,
  isActive,
  dashboardLoading,
  dashboardError,
  glanceCards,
  alertCards,
  alertsRef,
}) => (
  <div className={`admin-tab ${isActive ? "admin-tab--active" : ""}`.trim()}>
    <section className="admin-hero admin-animate admin-animate--delay-1">
      <div className="admin-hero__content">
        <span className="admin-hero__eyebrow">
          {t("admin.hero.eyebrow", "Owner only")}
        </span>
        <h1>{t("admin.hero.heading", "Wayli admin control room")}</h1>
      </div>
    </section>

    <section className="admin-section admin-animate admin-animate--delay-2">
      <header>
        <div>
          <p className="admin-section__eyebrow">
            {t("admin.home.eyebrow", "What you see")}
          </p>
          <h2>{t("admin.home.heading", "At a glance")}</h2>
        </div>
      </header>
      {dashboardLoading ? (
        <p className="admin-empty">
          {t("admin.stats.loading", "Loading dashboard metrics...")}
        </p>
      ) : dashboardError ? (
        <p className="admin-empty">{dashboardError}</p>
      ) : glanceCards.length === 0 ? (
        <p className="admin-empty">
          {t("admin.stats.empty", "No metrics available yet.")}
        </p>
      ) : (
        <div className="admin-overview__cards">
          {glanceCards.map((card) => (
            <article
              key={card.id}
              className={`admin-metric admin-metric--${card.tone}`.trim()}
            >
              <p className="admin-metric__label">{card.label}</p>
              <p className="admin-metric__value">{card.value}</p>
              <p className="admin-metric__detail">{card.detail}</p>
            </article>
          ))}
        </div>
      )}
    </section>

    <OperationalSnapshotCard isActive={isActive} />

    <section
      ref={alertsRef}
      className="admin-section admin-alerts admin-animate admin-animate--delay-4"
    >
      <header>
        <div>
          <p className="admin-section__eyebrow">
            {t("admin.alerts.eyebrow", "Alerts")}
          </p>
          <h2>{t("admin.alerts.heading", "Operational alerts")}</h2>
        </div>
      </header>
      <div className="admin-alerts__grid">
        {dashboardLoading ? (
          <p className="admin-empty">
            {t("admin.stats.loading", "Loading dashboard metrics...")}
          </p>
        ) : dashboardError ? (
          <p className="admin-empty">{dashboardError}</p>
        ) : alertCards.length === 0 ? (
          <article className="admin-alert admin-alert--info">
            <div className="admin-alert__header">
              <h3>{t("admin.alerts.none.title", "No active alerts")}</h3>
              <span className="admin-pill admin-pill--info">
                {t("admin.alerts.none.tag", "All clear")}
              </span>
            </div>
            <p className="admin-alert__detail">
              {t(
                "admin.alerts.none.detail",
                "No overdue returns, cancellations, or payment issues today."
              )}
            </p>
          </article>
        ) : (
          alertCards.map((alert) => (
            <article
              key={alert.id}
              className={`admin-alert admin-alert--${alert.severity}`.trim()}
            >
              <div className="admin-alert__header">
                <h3>{alert.title}</h3>
                <span className={`admin-pill admin-pill--${alert.severity}`}>
                  {alert.value}
                </span>
              </div>
              <p className="admin-alert__detail">{alert.detail}</p>
              <p className="admin-alert__time">
                {t("admin.alerts.today", "Today")}
              </p>
            </article>
          ))
        )}
      </div>
    </section>
  </div>
);

export default AdminHomeTab;
